import { isLoading } from '../../Loading/isLoading';
import { isError } from '../../Loading/isError';
import { toastr } from 'react-redux-toastr';
import { ENDPOINTS } from '../constants';
import { apiGet } from '../apiHelpers';

export const apiCompanySearch = (keyword, maxResults = 10) => async (dispatch, getState) => {
    const type = ENDPOINTS.API.COMPANY_SEARCH;

    isLoading(dispatch, type, true, {});
    try {
        dispatch(apiGet(type, ['company', 'search', keyword], { maxResults }));
    } catch (error) {
        isError(dispatch, type, true, error.message, {});
        toastr.error(type, `Response ${error.message}`);
        return false;
    }
};
